import $ from 'jquery';
import 'jquery-ui';

$(document).ready(function () {
    initBannerInfoAnimation();
    handleSkeletonContainers();
    setupIntersectionObserver();
    setupBannerSlider();
    handleBannerSliderEvents();
    setupVideoHandlers();
    setupResponsiveSliders();
    setupScrollAnimations();
    updateTimer();
});

function renderAlert(text, colorClass, duration, undo = '') {
    const alertId = `alert-${new Date().getTime()}`;
    const alertHtml = `
        <div id="${alertId}" class="custom-alerts" style="display: none">
            <div class="${colorClass} alert">
                <img class="custom-alert-img" src="/img/notifications/${colorClass}.svg" alt="">
                <div class="custom-alert-label">
                    ${text}
                    ${undo}
                </div>
                <button type="button" class="close close-alert">×</button>
            </div>
        </div>
    `;

    $('body').append(alertHtml);
    $(`#${alertId}`).show();
    $('#' + alertId).css('bottom', '50px');
    setTimeout(function(){
        $('#' + alertId).css('bottom', '-100px');
        setTimeout(()=>{
            $(this).remove();
        }, 500)
    }, duration)
}

function CopyToClipboard(copyStr) {
    var copytext = document.createElement('input');
        copytext.value = copyStr;

    document.body.appendChild(copytext);
    copytext.select();
    document.execCommand('copy');
    document.body.removeChild(copytext);
}

function initBannerInfoAnimation() {
    $('.banner .banner__info-wrap').addClass('animate');
}

function handleSkeletonContainers() {
    setTimeout(() => {
        $('.skeleton-container-news').css('opacity', 0);
        $('.news-wrap').css('opacity', 1);
        setTimeout(() => {
            $('.skeleton-container-news').css('display', 'none');
        }, 500);
    }, 1000);
}

function setupIntersectionObserver() {
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                lazyLoadAjax(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.1 });

    $('.products-block').each(function () {
        observer.observe(this);
    });
}

async function lazyLoadAjax(element) {
    const block = $(element);
    const cardType = block.attr('data-type');
    const langVersion = $('html').attr('data-lang');

    try {
        const content = block.find('.slider-landing-products');

        const response = await $.ajax({
            url: `/${langVersion}/site/${cardType}`,
            method: 'GET'
        });

        if (response.length) {
            content.html(response);
            if ($(window).width() < 992) {
                initSlider(content);
                $(content).slick('slickNext');
            }

            setTimeout(() => {
                content.css('opacity', 1);
                block.find('.skeleton-container').css('opacity', 0);
            }, 500);

            setTimeout(() => {
                block.find('.skeleton-container').css('display', 'none');
            }, 1000);
        }
    } catch (error) {
        console.error('AJAX error for cards: ' + cardType);
    }
}

function initSlider(content) {
    content.slick({
        infinite: true,
        slidesToShow: 2,
        centerMode: false,
        swipeToSlide: true,
        arrows: false,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    variableWidth: true,
                    arrows: false,
                    initialSlide: 1,
                },
            },
        ],
    });
}

function setupBannerSlider() {
    $('.banner').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: false,
        draggable: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        dots: true,
        speed: 500,
        fade: true,
        appendDots: $('.banner__info-wrap .banner__dots'),
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    appendDots: $('.container-dots'),
                    fade: false,
                    swipeToSlide: true,
                    draggable: true,
                },
            },
        ],
    });
}

function handleBannerSliderEvents() {
    $('.banner').on('afterChange', function (event, slick, currentSlide) {
        $('.banner__dots li').removeClass('active');
        $('.banner__dots li:nth-child(' + (currentSlide + 1) + ')').addClass('slick-active');
    });

    if ($(window).width() > 768) {
        var autoplaySpeed = $('.banner').slick('slickGetOption', 'autoplaySpeed');
        var remainingTimeToNextSlide = autoplaySpeed;

        $('.banner').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.banner').slick('slickSetOption', 'autoplaySpeed', 5000);
            remainingTimeToNextSlide = autoplaySpeed;
        });

        var intervalID = setInterval(function () {
            if (remainingTimeToNextSlide > 0) {
                remainingTimeToNextSlide -= 500;
            }
        }, 500);

        $('.banner__info-wrap').mouseenter(function () {
            if ($(window).width() > 768) {
                clearInterval(intervalID);
                $('.banner').slick('slickPause');
                $('.banner').slick('slickSetOption', 'autoplaySpeed', remainingTimeToNextSlide);
            }
        });

        $('.banner__info-wrap').mouseleave(function () {
            if ($(window).width() > 768) {
                $('.banner').slick('slickPlay');
                clearInterval(intervalID);
                intervalID = setInterval(function () {
                    if (remainingTimeToNextSlide > 0) {
                        remainingTimeToNextSlide -= 50;
                    }
                }, 50);
            }
        });
    }
}

function updateTimer() {
    let now = new Date();
    let endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    let totalSeconds = Math.floor((endOfDay - now) / 1000);
    let blockTimer = $('.deal-week-block__content-timer-el');

    let hours = Math.floor(totalSeconds / 3600);
    let minutes = Math.floor((totalSeconds % 3600) / 60);
    let seconds = totalSeconds % 60;

    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    $(blockTimer).find('.hoursLanding').text(hours);
    $(blockTimer).find('.minutesLanding').text(minutes);
    $(blockTimer).find('.secondsLanding').text(seconds);

    setTimeout(updateTimer, 1000);
}

function setupVideoHandlers() {
    $(document).on("mouseenter", ".js-video-container", function () {
        if ($(window).width() > 768) {
            const container = $(this);
            const videoSrc = container.find('.home-cart__video-wrap').attr('data-video');
            const videoPlayer = container.find(".js-video-player")[0];
            if (videoPlayer) {
                const source = $(videoPlayer).find('source');
                source.attr('src', videoSrc);
                videoPlayer.load();
                videoPlayer.muted = true;
                videoPlayer.pause();
                videoPlayer.oncanplay = () => {
                    videoPlayer.play().then(function () {
                        container.addClass("preloaded");
                    }).catch(function (error) {
                        console.log("Failed to play video:", error);
                    });
                };
            }
        }
    });

    $(document).on("mouseleave", ".js-video-container", function () {
        if ($(window).width() > 768) {
            const container = $(this);
            const videoPlayer = container.find(".js-video-player");
            const source = $(videoPlayer).find('source');
            source.attr('src', '');
            container.removeClass("preloaded");
            if (videoPlayer.length) {
                videoPlayer[0].pause();
            }
        }
    });
}

function setupResponsiveSliders() {
    if ($(window).width() < 768) {
        let sliderPlatform = $('.slider-platforms, .news-wrap-slider');
        sliderPlatform.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            swipeToSlide: true,
            arrows: false,
            variableWidth: true,
        });
    }
}

function setupScrollAnimations() {
    if ($(window).width() > 768 && $('.best-release-block').length || $('.deal-week-block').length) {
        $(window).scroll(function () {
            if(!$('.best-release-block').length || $('.deal-week-block').length) return;
            let scrollPosition = $(window).scrollTop();
            let targetPositionRelease = $('.best-release-block').offset().top;
            let targetPositionDealWeek = $('.deal-week-block').offset()?.top;

            if (scrollPosition < 800) {
                $('.banner__info-wrap').css('transform', 'translateY(' + scrollPosition / 4 + 'px)');
            } else if (scrollPosition >= (targetPositionRelease - 500) && scrollPosition <= (targetPositionRelease + 500)) {
                let blockAnimate = (scrollPosition - targetPositionRelease) / 14;
                $('.best-release-block .best-release-block__content').css('transform', 'translateY(' + blockAnimate + 'px)');
            } else if (scrollPosition >= (targetPositionDealWeek - 500) && scrollPosition <= (targetPositionDealWeek + 500)) {
                let blockAnimate = (scrollPosition - targetPositionDealWeek) / 14;
                $('.deal-week-block .deal-week-block__content').css('transform', 'translateY(' + blockAnimate + 'px)');
            }
        });
    }
}

// $(document).on("click", ".christmas-banner .promo-code", function () {
//     const alertText = $(this).closest('.christmas-banner').data('alert')
//     const alertCode = $(this).closest('.christmas-banner').data('code')
//     renderAlert(alertText,'success',3000)
//     CopyToClipboard(alertCode)
// });